import {
  VIDEO_GET_ARTICLES_REQUEST,
  VIDEO_GET_ARTICLES_SUCCESS,
  VIDEO_GET_ARTICLES_FAIL,
  VIDEO_GET_CATEGORIES_REQUEST,
  VIDEO_GET_CATEGORIES_SUCCESS,
  VIDEO_GET_CATEGORIES_FAIL,
  VIDEO_REMOVE_ARTICLE_REQUEST,
  VIDEO_REMOVE_ARTICLE_SUCCESS,
  VIDEO_REMOVE_ARTICLE_FAIL,
  VIDEO_GET_ARTICLE_REQUEST,
  VIDEO_GET_ARTICLE_SUCCESS,
  VIDEO_GET_ARTICLE_FAIL,
  VIDEO_EDIT_ARTICLE_REQUEST,
  VIDEO_EDIT_ARTICLE_SUCCESS,
  VIDEO_EDIT_ARTICLE_FAIL,
  VIDEO_CREATE_ARTICLE_REQUEST,
  VIDEO_CREATE_ARTICLE_SUCCESS,
  VIDEO_CREATE_ARTICLE_FAIL
} from "../actions/video";

const initialState = {
  getArticlesRequest: false,
  getArticleRequest: false,
  getAuthorsRequest: false,
  removeArticleRequest: false,
  getCategoriesRequest: false,
  categories: [],
  errorMsg: "",
  successMsg: "",
  errors: {},
  articles: [],
  authors: [],
  articlesPagination: {},
  selectedArticle: {},
  editArticleRequest: false,
  successBackMsg: "",
  selectedArticles: [],
};

const video = (state = initialState, action) => {
  switch (action.type) {
    case VIDEO_GET_ARTICLES_REQUEST:
      return {
        ...state,
        getArticlesRequest: true,
          errorMsg: "",
          successMsg: "",
          errors: {}
      };
    case VIDEO_GET_ARTICLES_SUCCESS:
      return {
        ...state,
        getArticlesRequest: false,
          errorMsg: "",
          successMsg: action.msg,
          errors: {},
          articles: action.data.data,
          articlesPagination: {
            currentPage: action.data.current_page,
            lastPage: action.data.last_page,
          }
      };
    case VIDEO_GET_ARTICLES_FAIL:
      return {
        ...state,
        getArticlesRequest: false,
          errorMsg: action.msg,
          successMsg: "",
          errors: action.errors
      };
    case VIDEO_GET_CATEGORIES_REQUEST:
      return {
        ...state,
        getCategoriesRequest: true,
          errorMsg: "",
          successMsg: "",
          errors: {}
      };
    case VIDEO_GET_CATEGORIES_SUCCESS:
      return {
        ...state,
        getCategoriesRequest: false,
          errorMsg: "",
          successMsg: action.msg,
          errors: {},
          categories: action.data,
      };
    case VIDEO_GET_CATEGORIES_FAIL:
      return {
        ...state,
        getCategoriesRequest: false,
          errorMsg: action.msg,
          successMsg: "",
          errors: action.errors
      };
    case VIDEO_REMOVE_ARTICLE_REQUEST:
      return {
        ...state,
        removeUserRequest: true,
          errorMsg: "",
          successMsg: "",
          errors: {},
          selectedArticle: {}
      };
    case VIDEO_REMOVE_ARTICLE_SUCCESS:
      return {
        ...state,
        removeUserRequest: false,
          errorMsg: "",
          successMsg: action.msg,
          errors: {},
          selectedArticle: {}
      };
    case VIDEO_REMOVE_ARTICLE_FAIL:
      return {
        ...state,
        removeUserRequest: false,
          errorMsg: action.msg,
          successMsg: "",
          errors: action.errors,
          selectedArticle: {}
      };
    case VIDEO_GET_ARTICLE_REQUEST:
      return {
        ...state,
        getArticleRequest: true,
          successMsg: "",
          errorMsg: "",
          errors: {},
          selectedArticle: {}
      };
    case VIDEO_GET_ARTICLE_SUCCESS:
      return {
        ...state,
        getArticleRequest: false,
          successMsg: "",
          errorMsg: "",
          errors: {},
          selectedArticle: action.data
      };
    case VIDEO_GET_ARTICLE_FAIL:
      return {
        ...state,
        getArticleRequest: false,
          successMsg: "",
          errorMsg: action.msg,
          errors: action.errors,
          selectedArticle: {}
      };
    case VIDEO_EDIT_ARTICLE_REQUEST:
      return {
        ...state,
        editArticleRequest: true,
          successBackMsg: "",
          errorMsg: "",
          errors: {},
      };
    case VIDEO_EDIT_ARTICLE_SUCCESS:
      return {
        ...state,
        editArticleRequest: false,
          successBackMsg: action.msg,
          errorMsg: "",
          errors: {},
      };
    case VIDEO_EDIT_ARTICLE_FAIL:
      return {
        ...state,
        editArticleRequest: false,
          successBackMsg: "",
          errorMsg: action.msg,
          errors: action.errors,
      };
    case VIDEO_CREATE_ARTICLE_REQUEST:
      return {
        ...state,
        editArticleRequest: true,
          successBackMsg: "",
          errorMsg: "",
          errors: {},
      };
    case VIDEO_CREATE_ARTICLE_SUCCESS:
      return {
        ...state,
        editArticleRequest: false,
          successBackMsg: action.msg,
          errorMsg: "",
          errors: {},
      };
    case VIDEO_CREATE_ARTICLE_FAIL:
      return {
        ...state,
        editArticleRequest: false,
          successBackMsg: "",
          errorMsg: action.msg,
          errors: action.errors,
      };

    default:
      return state;
  }
};

export default video;